import * as Yup from 'yup'

import { CNPJValidator } from '../../../utils'

export default Yup.object().shape({
    email: Yup.string().email('Digite um e-mail válido!').required('E-mail é obrigatório!'),
    cnpj: Yup.string().required('CNPJ é obrigatório!').test('CNPJ', 'Digite um CNPJ válido!', CNPJValidator.validate)
})